// tslint:disable
export enum PrescriberLicenseType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description DRUG ENFORCEMENT ADMINISTRATION NUMBER
     */
    DRUGENFORCEMENTADMINISTRATIONNUMBER = 1,
    /**
     * @description STATE LICENSE ID
     */
    STATELICENSEID = 2,
    /**
     * @description MEDICAID ID
     */
    MEDICAIDID = 3,
    /**
     * @description STATE TAX ID
     */
    STATETAXID = 4,
}
